import { footerInfo } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="flex flex-col gap-4">
            <a
              href="#hero"
              onClick={(e) => handleClick(e, '#hero')}
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center text-xl">
                <i className="ri-chat-smile-2-line text-primary-500"></i>
              </div>
              <span className="text-lg font-heading text-foreground-900">
                {footerInfo.name}
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed">{footerInfo.desc}</p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-900 mb-4">
              {footerInfo.sections.explore.title}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerInfo.sections.explore.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-900 mb-4">
              {footerInfo.sections.support.title}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerInfo.sections.support.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-900 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              樱花漫画与多家漫画创作平台、出版社保持紧密合作，共同推动优质漫画内容的传播与发展。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 {footerInfo.name} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            免费漫画全集下拉式阅读 | 好看的漫画推荐与追更
          </p>
        </div>
      </div>
    </footer>
  );
}